import type { FC } from "react";

import { getAssignedDataGroup } from "../../../../core/router/auth";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { AntCustomFormField } from "../../types/types";
import { IdGenerator } from "../IdGenerator/IdGenerator";

interface InputGeneratorProps extends AntCustomFormField<string> {
    label: string;
    readOnly: boolean;
    name: string;
    siteId: string;
}

export const SiteIdCopyGenerator: FC<InputGeneratorProps> = ({ siteId, ...restProps }) => {
    const fetchUrl = `/${ResourceName.SITE_ID_COPY_GENERATOR}?siteId=${siteId}`;

    const dataGroup = getAssignedDataGroup();
    const disableButton: boolean = !(dataGroup?.siteIdMinLength && dataGroup?.siteIdMaxLength && dataGroup?.siteIdPrefixes);

    return (
        <IdGenerator fetchUrl={fetchUrl} buttonName="siteIdGenerator_button" showSpinner buttonIsDisabled={disableButton} {...restProps} />
    );
};
